import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="role-details"
export default class extends Controller {
  static targets = ["details", "select", "organization", "department", "seniority", "employmentType", "status"]

  connect() {
    // If a role is pre-selected, load its details on page load
    if (this.hasSelectTarget && this.selectTarget.value) {
      this.loadRoleDetailsFromSelect(this.selectTarget)
    }
  }

  loadRoleDetails(event) {
    this.loadRoleDetailsFromSelect(event.target)
  }

  loadRoleDetailsFromSelect(selectElement) {
    const selectedOption = selectElement.selectedOptions[0]

    if (!selectedOption || !selectedOption.value) {
      // Hide details when no role is selected
      this.detailsTarget.classList.add("hidden")
      return
    }

    // Extract role data from the selected option
    const roleData = {
      title: selectedOption.dataset.roleTitle,
      organization: selectedOption.dataset.roleOrganization,
      department: selectedOption.dataset.roleDepartment,
      seniority: selectedOption.dataset.roleSeniority,
      employmentType: selectedOption.dataset.roleEmploymentType,
      status: selectedOption.dataset.roleStatus
    }

    // Update the UI with role information
    this.updateRoleDetails(roleData)

    // Show the details section
    this.detailsTarget.classList.remove("hidden")
  }

  updateRoleDetails(roleData) {
    // Update basic information
    this.organizationTarget.textContent = roleData.organization || "-"
    this.departmentTarget.textContent = roleData.department || "-"
    this.seniorityTarget.textContent = this.formatSeniorityLevel(roleData.seniority)
    this.employmentTypeTarget.textContent = this.formatEmploymentType(roleData.employmentType)

    // Update status with appropriate styling
    this.statusTarget.textContent = this.formatStatus(roleData.status)
    this.statusTarget.className = this.getStatusClasses(roleData.status)
  }

  formatSeniorityLevel(level) {
    if (!level) return "-"
    return level.split('_').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ')
  }

  formatEmploymentType(type) {
    if (!type) return "-"
    return type.split('_').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ')
  }

  formatStatus(status) {
    if (!status) return "-"
    return status.charAt(0).toUpperCase() + status.slice(1)
  }

  getStatusClasses(status) {
    const baseClasses = "text-sm font-medium inline-flex px-2 py-1 rounded-full text-xs"

    switch(status) {
      case 'active':
        return `${baseClasses} bg-green-100 text-green-800`
      case 'draft':
        return `${baseClasses} bg-yellow-100 text-yellow-800`
      case 'closed':
        return `${baseClasses} bg-red-100 text-red-800`
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`
    }
  }
}
